(function () {
  'use strict';

  (function redirectCollectionPagedLandings() {
    var url = new URL(window.location.href);
    if (!/^\/(?:[a-z]{2}\/)?collections\//.test(url.pathname)) return;
    var p = url.searchParams.get('page');
    if (!p || p === '1') return;
    url.searchParams.delete('page');
    window.location.replace(url.toString());
  })();

  function injectControlBarStyles() {
    if (document.getElementById('tk-globo-controlbar-style')) return;
    var s = document.createElement('style');
    s.id = 'tk-globo-controlbar-style';
    s.textContent = [
      '@media (max-width: 989px) {',
      '  #gf-controls-container { padding: 0 !important; }',
      '  .gf-actions {',
      '    display: flex !important;',
      '    flex-wrap: wrap !important;',
      '    align-items: center !important;',
      '    justify-content: flex-end !important;',
      '    gap: 8px !important;',
      '    margin: 0 0 16px !important;',
      '    padding: 0 4px !important;',
      '    border: 0 !important; background: transparent !important;',
      '  }',
      '  .gf-filter-trigger { margin-right: auto !important; }',

      '  .gf-filter-selection {',
      '    display: contents !important;',
      '  }',

      '  .gf-summary { display: none !important; }',

      '  .gf-filter-trigger {',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    margin: 0 auto 0 0 !important;',
      '    padding: 0 !important;',
      '    border: 0 !important; background: transparent !important; box-shadow: none !important;',
      '  }',

      '  .gf-refine-toggle-mobile,',
      '  .theme-store-id-3627.spf-filter-tree-theme.spf-has-filter #gf-controls-container .gf-refine-toggle-mobile {',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    margin: 0 !important; padding: 0 !important;',
      '    border: 0 !important; background: transparent !important;',
      '    box-shadow: none !important; border-radius: 12px !important;',
      '    height: 41px !important;',
      '  }',

      '  .gf-refine-toggle-mobile > span,',
      '  .gf-filter-selection .sort-by,',
      '  .gf-filter-selection .sort-by.limit-by,',
      '  .sort-by, .sort-by.limit-by {',
      '    width: auto !important;',
      '    flex: 0 0 auto !important;',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    justify-content: center !important;',
      '    gap: 8px !important;',
      '    height: 41px !important;',
      '    padding: 0 18px !important;',
      '    border: 1px solid rgba(0, 0, 0, 0.08) !important;',
      '    border-radius: 12px !important;',
      '    background: #fff !important;',
      '    color: #3B1B31 !important;',
      '    font-family: inherit !important;',
      '    font-size: 14px !important;',
      '    font-weight: 600 !important;',
      '    letter-spacing: 0.01em !important;',
      '    line-height: 1 !important;',
      '    white-space: nowrap !important;',
      '    cursor: pointer !important;',
      '    box-shadow: 0 1px 2px rgba(59, 27, 49, 0.04), 0 2px 8px rgba(59, 27, 49, 0.04) !important;',
      '    margin: 0 !important;',
      '    transition: border-color 0.15s ease, transform 0.15s ease !important;',
      '  }',

      '  .gf-refine-toggle-mobile,',
      '  .gf-refine-toggle-mobile:hover,',
      '  .gf-refine-toggle-mobile:focus,',
      '  .gf-refine-toggle-mobile > span:hover,',
      '  .gf-refine-toggle-mobile > span:focus,',
      '  .gf-refine-toggle-mobile > span:focus-visible,',
      '  .sort-by:hover, .sort-by:focus,',
      '  .sort-by.limit-by:hover, .sort-by.limit-by:focus,',
      '  .gf-filter-selection .sort-by:hover,',
      '  .gf-filter-selection .sort-by.limit-by:hover {',
      '    border-color: rgba(0, 0, 0, 0.08) !important;',
      '    background: #fff !important;',
      '    transform: none !important;',
      '    box-shadow: 0 1px 2px rgba(59, 27, 49, 0.04), 0 2px 8px rgba(59, 27, 49, 0.04) !important;',
      '    outline: none !important;',
      '    transition: none !important;',
      '  }',

      '  .gf-refine-toggle-mobile i, .gf-refine-toggle-mobile svg {',
      '    width: 16px !important; height: 16px !important; flex-shrink: 0 !important; margin: 0 !important;',
      '  }',

      '  .gf-refine-toggle-mobile .gf-refine-toggle {',
      '    border: 0 !important; padding: 0 !important; background: transparent !important;',
      '  }',

      '  .sort-by label, .sort-by .sort-by-toggle {',
      '    font-family: inherit !important;',
      '    font-size: 14px !important; font-weight: 600 !important;',
      '    color: #3B1B31 !important; line-height: 1 !important;',
      '    margin: 0 !important; padding: 0 !important; border: 0 !important;',
      '    background: transparent !important;',
      '    cursor: pointer !important;',
      '    white-space: nowrap !important;',
      '    box-shadow: none !important;',
      '    display: inline-flex !important; align-items: center !important; gap: 6px !important;',
      '  }',

      '  .sort-by select.sortby-select {',
      '    appearance: none !important; -webkit-appearance: none !important;',
      '    background: transparent !important; border: 0 !important;',
      '    margin: 0 !important; padding: 0 16px 0 4px !important;',
      '    font: inherit !important; font-weight: 600 !important;',
      '    color: #3B1B31 !important;',
      '    cursor: pointer !important;',
      '    width: auto !important; height: auto !important; line-height: 1 !important;',
      '    background-image: url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\' viewBox=\'0 0 10 6\' fill=\'none\'%3E%3Cpath d=\'M1 1l4 4 4-4\' stroke=\'%233B1B31\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") !important;',
      '    background-repeat: no-repeat !important;',
      '    background-position: right 0 center !important;',
      '    background-size: 10px 6px !important;',
      '  }',

      '  .sort-by .sort-by-toggle::after {',
      '    content: "" !important;',
      '    display: inline-block !important;',
      '    width: 10px !important; height: 6px !important;',
      '    background: url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\' viewBox=\'0 0 10 6\' fill=\'none\'%3E%3Cpath d=\'M1 1l4 4 4-4\' stroke=\'%233B1B31\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") no-repeat center / contain !important;',
      '    margin-left: 4px !important;',
      '  }',

      '  .sort-by::before, .sort-by::after,',
      '  .sort-by.limit-by::before, .sort-by.limit-by::after {',
      '    content: none !important; display: none !important;',
      '  }',
      '}',

      '.theme-store-id-3627.spf-filter-tree-theme.spf-has-filter .gf-option-block .gf-block-title .gf-clear {',
      '  display: inline-block !important;',
      '  cursor: pointer;',
      '  text-decoration: underline;',
      '  font-size: 12px;',
      '  color: #9A8F85;',
      '  margin-left: auto;',
      '  flex-shrink: 0;',
      '}',
      '.theme-store-id-3627.spf-filter-tree-theme.spf-has-filter .gf-option-block .gf-block-title .gf-clear:hover {',
      '  color: #3B1B31;',
      '}',

      '#gf-tree .globo-selected-items-wrapper {',
      '  display: block !important;',
      '  margin: 0 0 12px !important;',
      '  padding: 0 0 12px !important;',
      '  border-bottom: 1px solid #e5e5e5;',
      '}',
      '#gf-tree .globo-selected-items-wrapper:not(:has(.selected-item)) {',
      '  display: none !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .gf-block-title { display: none !important; }',
      '#gf-tree .globo-selected-items-wrapper .gf-block-content {',
      '  display: flex !important;',
      '  flex-wrap: wrap !important;',
      '  gap: 6px !important;',
      '  padding: 0 !important;',
      '  background: transparent !important;',
      '  border: 0 !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .clear-refinements {',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  gap: 5px !important;',
      '  order: 99 !important;',
      '  margin: 0 !important;',
      '  padding: 4px 10px !important;',
      '  font-size: 11.5px !important;',
      '  font-weight: 600 !important;',
      '  line-height: 1 !important;',
      '  color: var(--tk-ink, #3B1B31) !important;',
      '  background: #fff !important;',
      '  border: 1px solid var(--tk-line, #e5e5e5) !important;',
      '  border-radius: var(--qty-radius, 8px) !important;',
      '  cursor: pointer !important;',
      '  white-space: nowrap !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .clear-refinements::before {',
      '  content: "\\00d7";',
      '  font-size: 14px !important;',
      '  line-height: 1 !important;',
      '  margin-top: -1px;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .clear-refinements:hover {',
      '  background: var(--tk-ink, #3B1B31) !important;',
      '  color: #fff !important;',
      '  border-color: var(--tk-ink, #3B1B31) !important;',
      '}',

      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label {',
      '  display: inline-flex !important;',
      '  align-items: center;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  border: 0 !important;',
      '  background: transparent !important;',
      '  width: auto !important;',
      '  max-width: 100% !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label > a {',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  gap: 6px !important;',
      '  padding: 4px 8px 4px 10px !important;',
      '  border: 1px solid #e5e5e5 !important;',
      '  border-radius: var(--qty-radius, 8px) !important;',
      '  background: #fafafa !important;',
      '  color: inherit !important;',
      '  text-decoration: none !important;',
      '  cursor: pointer !important;',
      '  line-height: 1 !important;',
      '  white-space: nowrap !important;',
      '  max-width: 100% !important;',
      '  overflow: hidden;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label > a:hover {',
      '  background: #fff !important;',
      '  border-color: #3B1B31 !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .selected-item {',
      '  display: inline-flex !important;',
      '  align-items: baseline !important;',
      '  gap: 4px;',
      '  flex-direction: row !important;',
      '  min-width: 0;',
      '  overflow: hidden;',
      '  text-overflow: ellipsis;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .selected-item > span:not(.hidden-xs) { display: none !important; }',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .selected-item .hidden-xs {',
      '  display: inline !important;',
      '  font-size: 11px !important;',
      '  font-weight: 400 !important;',
      '  color: #9A8F85 !important;',
      '  letter-spacing: 0 !important;',
      '  text-transform: none !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label strong {',
      '  font-weight: 600 !important;',
      '  font-size: 12px !important;',
      '  color: #3B1B31 !important;',
      '  overflow: hidden;',
      '  text-overflow: ellipsis;',
      '  max-width: 140px;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label strong .gf-label {',
      '  font-size: 12px !important; font-weight: 600 !important; color: #3B1B31 !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .gf-clear {',
      '  display: inline-flex !important;',
      '  align-items: center;',
      '  justify-content: center;',
      '  width: 14px !important;',
      '  height: 14px !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  border: 0 !important;',
      '  background: transparent !important;',
      '  color: #999 !important;',
      '  flex-shrink: 0;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label .gf-clear svg {',
      '  width: 14px !important; height: 14px !important;',
      '}',
      '#gf-tree .globo-selected-items-wrapper .selected-item.gf-option-label > a:hover .gf-clear { color: #3B1B31 !important; }',

      '#gf-tree .gf-option-block .gf-block-title .gf-clear {',
      '  font-size: 11px !important;',
      '  font-weight: 400 !important;',
      '  color: #9A8F85 !important;',
      '  text-decoration: none !important;',
      '  border-bottom: 1px solid #c5c5c5;',
      '  line-height: 1 !important;',
      '  padding: 0 !important;',
      '  margin-left: 8px !important;',
      '}',
      '#gf-tree .gf-option-block .gf-block-title .gf-clear:hover {',
      '  color: #3B1B31 !important;',
      '  border-bottom-color: #3B1B31 !important;',
      '}',

      '@media (max-width: 989px) {',
      '  #gf-tree { font-size: 12px !important; }',
      '  #gf-tree .gf-option-block { padding: 8px 0 !important; }',
      '  #gf-tree .gf-block-title .h3 span { font-size: 12.5px !important; }',
      '  #gf-tree .gf-label { font-size: 12.5px !important; }',
      '  #gf-tree .gf-count { font-size: 11px !important; }',
      '  #gf-tree .gf-search {',
      '    font-size: 16px !important;',
      '    padding: 7px 10px 7px 28px !important;',
      '    background-position: 8px 50% !important;',
      '    background-size: 14px !important;',
      '    height: auto !important;',
      '  }',
      '  #gf-tree .gf-range-inputs input[type="text"] {',
      '    font-size: 16px !important;',
      '  }',
      '  #gf-tree .gf-block-content { padding-top: 4px !important; }',
      '  #gf-tree .gf-option-box li { padding: 0 !important; }',
      '  #gf-tree .gf-option-box li > div { padding: 0 !important; margin: 0 !important; }',
      '  #gf-tree .gf-option-box li a { padding: 3px 0 !important; line-height: 1.35 !important; }',
      '  #gf-tree .tk-filter-chip { font-size: 11px !important; padding: 3px 9px !important; }',
      '  #gf-tree .gf-range-inputs input { font-size: 12px !important; height: 30px !important; }',
      '}',

      '#gf-tree .gf-option-box li { padding: 0 !important; margin: 0 !important; }',
      '#gf-tree .gf-option-box li > div { padding: 0 !important; margin: 0 !important; }',
      '#gf-tree .gf-option-box li a { padding: 5px 0 !important; }',
      '#gf-tree .gf-search { padding-left: 28px !important; background-position: 8px 50% !important; background-size: 14px !important; }',

      '.globo-dropdown-custom__options { z-index: 9999 !important; position: absolute !important; }',
      '.sort-by, .sort-by.limit-by { position: relative !important; z-index: 5; }',
      '.sort-by[aria-expanded="true"], .sort-by:has([aria-expanded="true"]) { z-index: 9999 !important; }',

      '@media (max-width: 989px) {',
      '  results-list { padding-block-start: 0 !important; padding-block-end: 24px !important; margin-top: -10px !important; }',
      '  .breadcrumb { padding-block: 10px 0 !important; margin: 0 !important; }',
      '  .breadcrumb nav, .breadcrumb ol, .breadcrumb ul { margin: 0 !important; padding: 0 !important; }',
      '  .breadcrumb a, .breadcrumb span, .breadcrumb li { font-size: 12px !important; line-height: 1.4 !important; }',
      '  #gf-controls-container { margin: 0 !important; padding: 0 !important; }',
      '  .gf-actions { margin: 0 0 8px !important; }',
      '}',

      '@media (max-width: 479px) {',
      '  .gf-actions {',
      '    gap: 6px !important;',
      '    flex-wrap: wrap !important;',
      '    align-items: center !important;',
      '  }',

      '  .globo-selected-items-wrapper:empty,',
      '  .globo-selected-items-wrapper:not(:has(.selected-item)) {',
      '    display: none !important;',
      '  }',

      '  .gf-filter-selection {',
      '    gap: 6px !important;',
      '    flex-wrap: wrap !important;',
      '    flex: 0 1 auto !important;',
      '    min-width: 0 !important;',
      '    align-items: center !important;',
      '  }',

      '  .gf-refine-toggle-mobile > span,',
      '  .gf-filter-selection .sort-by,',
      '  .gf-filter-selection .sort-by.limit-by,',
      '  .sort-by, .sort-by.limit-by {',
      '    padding: 0 14px !important;',
      '    font-size: 13px !important;',
      '    height: 41px !important;',
      '    gap: 6px !important;',
      '    flex: 0 0 auto !important;',
      '    width: auto !important;',
      '    max-width: 100% !important;',
      '    min-width: 0 !important;',
      '  }',

      '  .sort-by.limit-by label { display: none !important; }',

      '  .sort-by .sort-by-toggle {',
      '    width: auto !important;',
      '    overflow: visible !important;',
      '    justify-content: center !important;',
      '  }',
      '  .sort-by .sort-by-toggle > span {',
      '    overflow: visible !important;',
      '    white-space: nowrap !important;',
      '    text-overflow: clip !important;',
      '  }',
      '  .sort-by select.sortby-select {',
      '    overflow: visible !important;',
      '    width: auto !important;',
      '    max-width: none !important;',
      '  }',

      '  .gf-refine-toggle-mobile i, .gf-refine-toggle-mobile svg {',
      '    width: 14px !important; height: 14px !important;',
      '  }',
      '}',

      '@media (max-width: 360px) {',
      '  .gf-refine-toggle-mobile > span,',
      '  .gf-filter-selection .sort-by,',
      '  .gf-filter-selection .sort-by.limit-by,',
      '  .sort-by, .sort-by.limit-by {',
      '    padding: 0 10px !important;',
      '    font-size: 12px !important;',
      '    height: 41px !important;',
      '  }',
      '}',

      '@media (min-width: 990px) {',
      '  results-list { margin-top: -16px !important; }',
      '  #gf-tree {',
      '    align-self: flex-start !important;',
      '    background: #fff !important;',
      '    border: 1px solid transparent !important;',
      '    border-radius: 16px !important;',
      '    box-shadow: 0 1px 2px rgba(59, 27, 49, 0.04), 0 2px 8px rgba(59, 27, 49, 0.04) !important;',
      '    padding: 6px 16px 14px !important;',
      '  }',
      '  #gf-grid { padding-top: 0 !important; padding-left: 0 !important; margin-right: -24px !important; }',
      '  #gf-products { padding-right: 0 !important; }',
      '  body:has(results-list) .breadcrumb {',
      '    display: flex !important;',
      '    align-items: center !important;',
      '    justify-content: space-between !important;',
      '    gap: 16px !important;',
      '    flex-wrap: wrap !important;',
      '    min-height: 67px;',
      '  }',
      '  .breadcrumb #gf-controls-container { margin: 6px 0 0 !important; padding: 0 !important; }',
      '  #gf-controls-container .gf-filter-selection { padding: 0 !important; }',
      '  .breadcrumb #gf-controls-container .gf-actions { margin: 0 !important; padding: 0 !important; }',
      '  .tk-search-row { flex-direction: row !important; align-items: center !important; gap: 16px !important; margin: 0 !important; }',
      '  .tk-search-row > search-page-input-component { flex: 1 1 auto !important; min-width: 0 !important; }',
      '  .tk-search-row > #gf-controls-container { flex: 0 0 auto !important; margin: 0 !important; padding: 0 !important; }',
      '  .tk-search-row > #gf-controls-container .gf-actions { justify-content: flex-end !important; margin: 0 !important; padding: 0 !important; }',
      '  #gf-controls-container { padding: 0 !important; }',
      '  #gf-controls-container .gf-actions {',
      '    display: flex !important;',
      '    align-items: center !important;',
      '    justify-content: flex-end !important;',
      '    gap: 8px !important;',
      '    margin: 0 0 20px !important;',
      '    padding: 0 4px !important;',
      '    border: 0 !important; background: transparent !important; box-shadow: none !important;',
      '  }',
      '  #gf-controls-container .gf-actions .gf-summary { display: none !important; }',
      '  #gf-controls-container .gf-actions .gf-filter-selection {',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    gap: 8px !important;',
      '    margin: 0 !important;',
      '    flex: 0 0 auto !important;',
      '  }',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by) {',
      '    width: auto !important;',
      '    flex: 0 0 auto !important;',
      '    display: inline-flex !important;',
      '    align-items: center !important;',
      '    justify-content: center !important;',
      '    gap: 8px !important;',
      '    height: 41px !important;',
      '    padding: 0 18px !important;',
      '    border: 1px solid transparent !important;',
      '    border-radius: 12px !important;',
      '    background: #fff !important;',
      '    color: #3B1B31 !important;',
      '    font-family: inherit !important;',
      '    font-size: 14px !important;',
      '    font-weight: 600 !important;',
      '    letter-spacing: 0.01em !important;',
      '    line-height: 1 !important;',
      '    white-space: nowrap !important;',
      '    cursor: pointer !important;',
      '    box-shadow: 0 1px 2px rgba(59, 27, 49, 0.04), 0 2px 8px rgba(59, 27, 49, 0.04) !important;',
      '    margin: 0 !important;',
      '    transition: box-shadow 0.15s ease !important;',
      '  }',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by):hover {',
      '    box-shadow: 0 2px 4px rgba(59, 27, 49, 0.08), 0 4px 12px rgba(59, 27, 49, 0.08) !important;',
      '  }',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by) label,',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by) .sort-by-toggle {',
      '    font-family: inherit !important;',
      '    font-size: 14px !important; font-weight: 600 !important;',
      '    color: #3B1B31 !important; line-height: 1 !important;',
      '    margin: 0 !important; padding: 0 !important; border: 0 !important;',
      '    background: transparent !important; cursor: pointer !important;',
      '    white-space: nowrap !important; box-shadow: none !important;',
      '    display: inline-flex !important; align-items: center !important; gap: 6px !important;',
      '  }',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by)::before,',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by)::after {',
      '    content: none !important; display: none !important;',
      '  }',
      '  #gf-controls-container .gf-actions .gf-filter-selection .sort-by:not(.limit-by) .sort-by-toggle::after {',
      '    content: "" !important;',
      '    display: inline-block !important;',
      '    width: 10px !important; height: 6px !important;',
      '    background: url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\' viewBox=\'0 0 10 6\' fill=\'none\'%3E%3Cpath d=\'M1 1l4 4 4-4\' stroke=\'%233B1B31\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") no-repeat center / contain !important;',
      '    margin-left: 4px !important;',
      '  }',
      '}',
    ].join('\n');
    document.head.appendChild(s);
  }

  function getActiveGloboFilterValues() {
    var url = new URL(window.location.href);
    var values = [];
    url.searchParams.forEach(function (val, key) {
      if (/^gf_\d+$/.test(key) && val) {
        val.split(',').forEach(function (v) {
          v = v.trim();
          if (v) values.push(v);
        });
      }
    });
    return values;
  }

  var productDataCache = {};
  function getProductData(handle) {
    if (productDataCache[handle]) return productDataCache[handle];
    var locale = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    productDataCache[handle] = fetch(locale + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productDataCache[handle];
  }

  function getCardHandle(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function pickBestVariantFromProduct(product, filterValues) {
    if (!product || !product.variants) return null;
    var bestId = null;
    var bestScore = 0;
    product.variants.forEach(function (v) {
      var opts = v.options || [];
      var score = 0;
      filterValues.forEach(function (fv) {
        if (opts.some(function (o) { return o === fv; })) score++;
      });
      if (score > bestScore) { bestScore = score; bestId = v.id; }
    });
    return bestId;
  }

  function findMatchingVariantId(card, filterValues) {
    if (!filterValues.length) return null;
    var raw = card.getAttribute('data-tk-variants');
    if (raw) {
      try {
        var map = JSON.parse(raw);
        var bestId = null;
        var bestScore = 0;
        Object.keys(map).forEach(function (vid) {
          var opts = map[vid];
          if (!Array.isArray(opts)) return;
          var score = 0;
          filterValues.forEach(function (fv) {
            if (opts.some(function (o) { return o === fv; })) score++;
          });
          if (score > bestScore) { bestScore = score; bestId = vid; }
        });
        return Promise.resolve(bestId);
      } catch (e) { }
    }
    var handle = getCardHandle(card);
    if (!handle) return Promise.resolve(null);
    return getProductData(handle).then(function (p) { return pickBestVariantFromProduct(p, filterValues); });
  }

  function applyCardVariantId(card, matchVid) {
    if (!matchVid) return;
    var currentVid = card.getAttribute('data-tk-variant-synced');
    if (String(currentVid) === String(matchVid)) return;
    card.setAttribute('data-tk-variant-synced', String(matchVid));
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try {
        var u = new URL(a.href);
        u.searchParams.set('variant', matchVid);
        a.href = u.toString();
      } catch (e) { }
    });
    ['data-variant-id', 'data-selected-variant-id'].forEach(function (attr) {
      card.querySelectorAll('[' + attr + ']').forEach(function (el) {
        el.setAttribute(attr, String(matchVid));
      });
    });
    if (typeof window.TKReapplyCardVariant === 'function') {
      window.TKReapplyCardVariant(card);
    }
  }

  function applyVariantSync(filterValues) {
    if (!filterValues.length) return;
    var cards = document.querySelectorAll('product-card');
    cards.forEach(function (card) {
      var result = findMatchingVariantId(card, filterValues);
      if (result && typeof result.then === 'function') {
        result.then(function (vid) { applyCardVariantId(card, vid); });
      } else {
        applyCardVariantId(card, result);
      }
    });
  }

  function syncVariantsFromFilter() {
    var values = getActiveGloboFilterValues();
    if (!values.length) {
      document.querySelectorAll('product-card[data-tk-variant-synced]').forEach(function (c) {
        c.removeAttribute('data-tk-variant-synced');
      });
    } else {
      applyVariantSync(values);
    }
    localizeProductLinks();
  }

  function localizeProductLinks() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root === '/') return;
    var prefix = root.replace(/\/$/, '');
    if (!prefix) return;
    var grid = document.querySelector('#gf-products, ul.product-grid');
    if (!grid) return;
    var links = grid.querySelectorAll('a[href^="/products/"], a[href^="' + window.location.origin + '/products/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      if (href.indexOf(prefix + '/products/') !== -1) continue;
      var pathStart = href.indexOf('/products/');
      if (pathStart < 0) continue;
      var newHref = href.slice(0, pathStart) + prefix + href.slice(pathStart);
      a.setAttribute('href', newHref);
    }
  }

  function normalizeEurPrices(root) {
    var scope = root || document.body || document;
    if (!scope) return;
    var nodes = scope.querySelectorAll('.price, .compare-at-price, .money, .noUi-value, .noUi-tooltip');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children && el.children.length > 0) continue;
      var txt = el.textContent || '';
      var m = txt.match(/^\s*€\s*([\d.,\s ]+?)\s*$/);
      if (!m) continue;
      if (el.classList.contains('price') || el.classList.contains('compare-at-price')) {
        el.innerHTML = m[1] + ' <span class="tk-cur">€</span>';
      } else {
        el.textContent = m[1] + ' €';
      }
    }
  }

  function normalizeCzkPrices(root) {
    var scope = root || document.body || document;
    if (!scope) return;
    var nodes = scope.querySelectorAll('.price, .compare-at-price, .money');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children && el.children.length > 0) continue;
      var txt = el.textContent || '';
      if (txt.indexOf('Kč') < 0) continue;
      var hasComma = txt.indexOf(',') >= 0;
      var hasPlainSpaceKc = / Kč/.test(txt);
      if (!hasComma && !hasPlainSpaceKc) continue;
      var next = txt;
      if (hasComma) next = next.replace(/,/g, ' ');
      if (hasPlainSpaceKc) next = next.replace(/ Kč/g, ' Kč');
      if (next === txt) continue;
      if (el.classList.contains('price') || el.classList.contains('compare-at-price')) {
        el.innerHTML = next.replace(/ Kč$/, ' <span class="tk-cur">Kč</span>');
      } else {
        el.textContent = next;
      }
    }
  }

  function normalizeCzkGloboRangeInputs(root) {
    if (!window.Shopify || !window.Shopify.currency || window.Shopify.currency.active !== 'CZK') return;
    var scope = root || document.body || document;
    if (!scope) return;
    var inputs = scope.querySelectorAll('.gf-range-min, .gf-range-max');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (document.activeElement === input) continue;
      var raw = (input.value || '').trim();
      if (!raw) continue;
      var num = parseFloat(raw.replace(/[,\s ]/g, ''));
      if (isNaN(num)) continue;
      var isMin = input.classList.contains('gf-range-min');
      var rounded = isMin ? Math.floor(num) : Math.ceil(num);
      var formatted = String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      if (input.value !== formatted) input.value = formatted;
    }
  }

  function normalizeEurGloboRangeInputs(root) {
    if (!window.Shopify || !window.Shopify.currency || window.Shopify.currency.active !== 'EUR') return;
    var scope = root || document.body || document;
    if (!scope) return;
    var inputs = scope.querySelectorAll('.gf-range-min, .gf-range-max');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (document.activeElement === input) continue;
      var raw = (input.value || '').trim();
      if (!raw) continue;
      var hasDot = raw.indexOf('.') >= 0;
      var hasComma = raw.indexOf(',') >= 0;
      var num;
      if (hasDot && hasComma) {
        num = parseFloat(raw.replace(/,/g, '').replace(/\s/g, ''));
      } else if (hasDot) {
        num = parseFloat(raw.replace(/\s/g, ''));
      } else if (hasComma) {
        if (/,\d{1,2}$/.test(raw)) {
          num = parseFloat(raw.replace(/\s/g, '').replace(',', '.'));
        } else {
          num = parseFloat(raw.replace(/,/g, '').replace(/\s/g, ''));
        }
      } else {
        num = parseFloat(raw.replace(/\s/g, ''));
      }
      if (isNaN(num)) continue;
      var hasFraction = (Math.round(num * 100) % 100) !== 0;
      var formatted;
      if (hasFraction) {
        var parts = num.toFixed(2).split('.');
        formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1];
      } else {
        formatted = String(Math.round(num)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
      if (input.value !== formatted) input.value = formatted;
    }
  }

  function normalizeCzkNoUiLabels(root) {
    if (!window.Shopify || !window.Shopify.currency || window.Shopify.currency.active !== 'CZK') return;
    var scope = root || document.body || document;
    if (!scope) return;
    var nodes = scope.querySelectorAll('.noUi-value, .noUi-tooltip');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children && el.children.length > 0) continue;
      var txt = el.textContent || '';
      if (txt.indexOf(',') < 0) continue;
      var next = txt;
      var prev = '';
      while (next !== prev) {
        prev = next;
        next = next.replace(/(\d),(?=\d{3}(?:\D|$))/g, '$1 ');
      }
      if (next !== txt) el.textContent = next;
    }
  }

  function isPriceSliderBlock(block) {
    return (block.getAttribute('data-filter-type') || '').trim().toLowerCase() === 'price';
  }

  function stripMoneyTokens(txt) {
    if (!txt) return txt;
    return txt
      .replace(/\s*(?:Kč|CZK|€|EUR)\s*/g, '')
      .replace(/(\d)[.,]00(?!\d)/g, '$1')
      .trim();
  }

  function stripCurrencyFromNonPriceSliders(root) {
    var blocks;
    if (root && root.classList && root.classList.contains('gf-option-block')) {
      blocks = [root];
    } else {
      var scope = root && root.querySelectorAll ? root : document;
      blocks = scope.querySelectorAll('.gf-option-block');
    }
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (!block.querySelector || !block.querySelector('.gf-range-slider')) continue;
      if (isPriceSliderBlock(block)) continue;
      var labels = block.querySelectorAll('.noUi-value, .noUi-tooltip');
      for (var j = 0; j < labels.length; j++) {
        var el = labels[j];
        if (el.children && el.children.length) continue;
        var t = el.textContent || '';
        var n = stripMoneyTokens(t);
        if (n !== t) el.textContent = n;
      }
      var inputs = block.querySelectorAll('.gf-range-min, .gf-range-max');
      for (var k = 0; k < inputs.length; k++) {
        var inp = inputs[k];
        if (document.activeElement === inp) continue;
        var iv = inp.value || '';
        var inn = stripMoneyTokens(iv);
        if (inn !== iv) inp.value = inn;
      }
    }
  }

  function fmtMoneyLabel(val) {
    var n = Number(val);
    if (isNaN(n)) return String(val);
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CZK';
    if (cur === 'CZK') {
      return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč';
    }
    var frac = Math.round(n * 100) % 100 !== 0;
    var s;
    if (frac) {
      var p = n.toFixed(2).split('.');
      s = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + p[1];
    } else {
      s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
    return s + (cur === 'EUR' ? ' €' : '');
  }

  function reconcileStaleSliderRanges(root) {
    var blocks;
    if (root && root.classList && root.classList.contains('gf-option-block')) {
      blocks = [root];
    } else {
      var scope = root && root.querySelectorAll ? root : document;
      blocks = scope.querySelectorAll('.gf-option-block');
    }
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (!block.querySelector) continue;
      var slider = block.querySelector('.gf-range-slider');
      if (!slider || !slider.noUiSlider || typeof slider.noUiSlider.updateOptions !== 'function') continue;
      if (block.contains(document.activeElement)) continue;
      var dMin = parseNum(slider.getAttribute('data-min'));
      var dMax = parseNum(slider.getAttribute('data-max'));
      if (isNaN(dMin) || isNaN(dMax) || dMax <= dMin) continue;
      var range = slider.noUiSlider.options.range || {};
      if (Number(range.min) === dMin && Number(range.max) === dMax) continue;
      var cellMin = parseNum((block.querySelector('.gf-range-min') || {}).value);
      var cellMax = parseNum((block.querySelector('.gf-range-max') || {}).value);
      var cur = slider.noUiSlider.get();
      var curMin = parseNum(Array.isArray(cur) ? cur[0] : cur);
      var curMax = parseNum(Array.isArray(cur) ? cur[1] : cur);
      var newMin = !isNaN(cellMin) ? cellMin : (isNaN(curMin) ? dMin : curMin);
      var newMax = !isNaN(cellMax) ? cellMax : (isNaN(curMax) ? dMax : curMax);
      newMin = Math.max(dMin, Math.min(newMin, dMax));
      newMax = Math.max(dMin, Math.min(newMax, dMax));
      try {
        slider.noUiSlider.updateOptions({ range: { min: dMin, max: dMax } }, false);
        slider.noUiSlider.set([newMin, newMax]);
      } catch (e) { continue; }
      var pips = slider.querySelectorAll('.noUi-value');
      if (pips.length >= 2) {
        var isPrice = isPriceSliderBlock(block);
        var loLabel = isPrice ? fmtMoneyLabel(dMin) : formatNum(dMin);
        var hiLabel = isPrice ? fmtMoneyLabel(dMax) : formatNum(dMax);
        if (pips[0].textContent.trim() !== loLabel) pips[0].textContent = loLabel;
        var last = pips[pips.length - 1];
        if (last.textContent.trim() !== hiLabel) last.textContent = hiLabel;
      }
    }
  }

  function localizeFilterSearchPlaceholders() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('en') !== 0) return;
    document.querySelectorAll('#gf-tree .gf-search').forEach(function (inp) {
      if (inp.placeholder !== 'Search') inp.placeholder = 'Search';
    });
  }

  function forceTreeFrameBg() {
    var tree = document.querySelector('#gf-tree');
    if (!tree) return;
    var isDesktop = !window.matchMedia || window.matchMedia('(min-width: 990px)').matches;
    if (isDesktop) {
      if (tree.style.getPropertyValue('background') !== '#fff') {
        tree.style.setProperty('background', '#fff', 'important');
      }
    } else if (tree.style.getPropertyValue('background')) {
      tree.style.removeProperty('background');
    }
  }
  window.addEventListener('resize', forceTreeFrameBg);

  function relocateControls() {
    var isDesktop = !window.matchMedia || window.matchMedia('(min-width: 990px)').matches;
    var bc = document.querySelector('.breadcrumb');
    var form = document.querySelector('.search-page-input__parent');
    var grid = document.getElementById('gf-grid');
    var all = document.querySelectorAll('#gf-controls-container');
    if (all.length > 1 && grid) {
      var inGrid = grid.querySelector('#gf-controls-container');
      if (inGrid) all.forEach(function (c) { if (c !== inGrid) c.remove(); });
    }
    var ctl = document.getElementById('gf-controls-container');
    if (!ctl) return;
    if (isDesktop && bc) {
      if (ctl.parentElement !== bc) bc.appendChild(ctl);
    } else if (isDesktop && form) {
      if (ctl.parentElement !== form) form.appendChild(ctl);
    } else if (grid) {
      if (ctl.parentElement !== grid) {
        var products = document.getElementById('gf-products');
        grid.insertBefore(ctl, products || grid.firstChild);
      }
    }
  }
  window.addEventListener('resize', relocateControls);

  function runSync() {
    if (
      !document.getElementById('gf-tree') &&
      !document.getElementById('gf-products') &&
      !document.querySelector('.gf-option-block')
    ) return;
    syncVariantsFromFilter();
    normalizeEurPrices();
    normalizeCzkPrices();
    normalizeCzkGloboRangeInputs();
    normalizeEurGloboRangeInputs();
    normalizeCzkNoUiLabels();
    reconcileStaleSliderRanges();
    stripCurrencyFromNonPriceSliders();
    localizeFilterSearchPlaceholders();
    forceTreeFrameBg();
    relocateControls();
    if (typeof scan === 'function') scan();
  }
  function scheduleSync() {
    requestAnimationFrame(runSync);
    var delays = [80, 200, 400, 700, 1500, 3000];
    delays.forEach(function (d) { setTimeout(runSync, d); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
  var gridObserver = new MutationObserver(function () { scheduleSync(); });
  var gridRoot = document.querySelector('#gf-products, ul.product-grid') || document.body;
  gridObserver.observe(gridRoot, { childList: true, subtree: true });
  window.addEventListener('popstate', scheduleSync);
  (function () {
    var origPush = history.pushState;
    history.pushState = function () {
      var ret = origPush.apply(this, arguments);
      pendingScrollCorrection = true;
      scheduleSync();
      setTimeout(correctScrollAfterFilter, 80);
      setTimeout(correctScrollAfterFilter, 300);
      setTimeout(correctScrollAfterFilter, 700);
      return ret;
    };
  })();

  var pendingScrollCorrection = false;
  var loadingTimeout = null;

  if ('scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
  }

  function getScrollAnchor() {
    var card = document.querySelector(
      '#gf-products > li:not(.hidden-box):not(.gf-empty),' +
      ' #gf-products .product-grid__item:not(.hidden-box),' +
      ' ul.product-grid > li.product-grid__item:not(.hidden-box)'
    );
    return card ||
           document.querySelector('#gf-products') ||
           document.querySelector('ul.product-grid');
  }

  function stickyHeaderBottom() {
    var h = document.querySelector('.tk-header[sticky]') ||
            document.querySelector('.tk-header');
    if (!h) return 12;
    var box = h.closest('.header-section') || h;
    var b = box.getBoundingClientRect().bottom;
    if (b < 0) b = 0;
    return b + 12;
  }

  function alignAnchorToHeader() {
    var a = getScrollAnchor();
    if (!a) return null;
    var delta = a.getBoundingClientRect().top - stickyHeaderBottom();
    if (delta < -1) { window.scrollBy(0, delta); return Math.abs(delta); }
    return 0;
  }

  var scrollCorrectRaf = 0;
  var userScrolledDuringCorrect = false;
  function onUserScrollAbort() { userScrolledDuringCorrect = true; }
  function stopScrollCorrect() {
    if (scrollCorrectRaf) cancelAnimationFrame(scrollCorrectRaf);
    scrollCorrectRaf = 0;
    window.removeEventListener('wheel', onUserScrollAbort);
    window.removeEventListener('touchstart', onUserScrollAbort);
    window.removeEventListener('keydown', onUserScrollAbort);
  }

  var gridMutatedSinceScroll = false;
  function scrollToTopForFilter() {
  }

  function showFilterLoading() {
    var grid = document.querySelector('#gf-products, ul.product-grid');
    if (!grid) return;
    grid.classList.add('tk-is-filtering');
    if (window.tkGridSkel) window.tkGridSkel.show(grid, window.tkGridSkel.columns(grid) * 3, true, 160, 'globo');
    if (loadingTimeout) clearTimeout(loadingTimeout);
    loadingTimeout = setTimeout(hideFilterLoading, 6000);
  }

  function hideFilterLoading() {
    var grid = document.querySelector('#gf-products, ul.product-grid');
    if (!grid) return;
    grid.classList.remove('tk-is-filtering');
    if (window.tkGridSkel) window.tkGridSkel.hide(grid, 'globo');
    if (loadingTimeout) { clearTimeout(loadingTimeout); loadingTimeout = null; }
  }

  function isFilterTriggerClick(target) {
    if (!target || !target.closest) return false;
    if (target.closest('.tk-filter-chip-more')) return false;
    if (target.closest('#gf-tree .gf-option-box a')) return true;
    if (target.closest('#gf-tree .gf-clear, #gf-tree .selected-item a, #gf-tree .clear-refinements, #gf-tree .gf-refine-toggle')) return true;
    if (target.closest('.tk-filter-chip')) return true;
    if (target.closest('#gf-tree .gf-apply, #gf-tree .gf-action button')) return true;
    return false;
  }

  var lastFilterClickTs = 0;
  document.addEventListener('click', function (e) {
    if (!isFilterTriggerClick(e.target)) return;
    lastFilterClickTs = performance.now();
    showFilterLoading();
    scrollToTopForFilter();
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.globo-dropdown-custom__options li[data-sort]')) {
      lastFilterClickTs = performance.now();
      showFilterLoading();
    }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('select.sortby-select')) {
      lastFilterClickTs = performance.now();
      showFilterLoading();
    }
  }, true);

  gridObserver.disconnect();
  gridObserver = new MutationObserver(function () {
    hideFilterLoading();
    gridMutatedSinceScroll = true;
    scheduleSync();
  });
  gridObserver.observe(gridRoot, { childList: true, subtree: true });

  window.addEventListener('popstate', function () {
    showFilterLoading();
    setTimeout(hideFilterLoading, 2000);
  });

  function correctScrollAfterFilter() {
    if (!pendingScrollCorrection) return;
    pendingScrollCorrection = false;
    if ((performance.now() - lastFilterClickTs) < 2500) return;
    scrollToTopForFilter();
  }

  (function preserveDrawerScroll() {
    var clickAnchorId = null;
    var clickAnchorOffset = 0;
    var lastWasUserScroll = true;

    function moveWrapperIntoContents() {
    }

    function getScrollEl() {
      var tree = document.getElementById('gf-tree');
      if (!tree) return null;
      var fc = tree.querySelector('.gf-filter-contents');
      if (fc) return fc;
      return tree;
    }

    function captureClickAnchor(target) {
      var block = target && target.closest && target.closest('#gf-tree .gf-option-block');
      if (!block) {
        clickAnchorId = null;
        return;
      }
      var el = getScrollEl();
      if (!el) return;
      var elTop = el.getBoundingClientRect().top;
      clickAnchorId = block.getAttribute('data-filter-id') || block.getAttribute('data-filter-type') || null;
      clickAnchorOffset = block.getBoundingClientRect().top - elTop;
    }

    function restore() {
      moveWrapperIntoContents();
      if (!clickAnchorId) return;
      var el = getScrollEl();
      if (!el) return;
      var newBlock = el.querySelector('[data-filter-id="' + clickAnchorId + '"]') ||
                     el.querySelector('[data-filter-type="' + clickAnchorId + '"]');
      if (!newBlock) return;
      var elTop = el.getBoundingClientRect().top;
      var currentOffset = newBlock.getBoundingClientRect().top - elTop;
      var diff = currentOffset - clickAnchorOffset;
      if (Math.abs(diff) < 1) return;
      lastWasUserScroll = false;
      var target = el.scrollTop + diff;
      var maxScroll = el.scrollHeight - el.clientHeight;
      if (target < 0) target = 0;
      if (target > maxScroll) target = maxScroll;
      el.scrollTop = target;
      setTimeout(function () { lastWasUserScroll = true; }, 100);
    }

    function snapshot() {}

    function getTreeScrollEl() { return getScrollEl(); }

    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.id === 'gf-tree' || (t.classList && t.classList.contains('gf-filter-contents')) ||
          (t.closest && t.closest('#gf-tree'))) {
        snapshot();
      }
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('#gf-tree .gf-option-block .gf-option-box a, #gf-tree .selected-item .gf-clear, #gf-tree .gf-clear, #gf-tree .gf-refine-toggle, #gf-tree .clear-refinements')) {
        captureClickAnchor(t);
      }
    }, true);

    var restoreScheduled = false;
    var restoreAttempts = 0;
    function scheduleRestore() {
      if (restoreScheduled) return;
      restoreScheduled = true;
      restoreAttempts = 0;
      function tick() {
        restore();
        restoreAttempts++;
        if (restoreAttempts < 6) {
          requestAnimationFrame(tick);
        } else {
          restoreScheduled = false;
        }
      }
      requestAnimationFrame(tick);
    }
    var treeContentObserver = new MutationObserver(scheduleRestore);
    function startObserver() {
      var tree = document.getElementById('gf-tree');
      if (!tree) return setTimeout(startObserver, 300);
      treeContentObserver.observe(tree, { childList: true, subtree: true });
    }
    startObserver();
  })();

  function getEmptyRescueCopy() {
    var t = window.tkI18n || {};
    return {
      title: t.filters_empty_title || 'No products match',
      subtitle: t.filters_empty_subtitle || 'The selected filter combination returned no results.',
      clearAll: t.filters_clear_all || 'Clear all filters',
      inStock: t.filters_in_stock || 'In stock',
    };
  }

  function getActiveFiltersFromUrl() {
    var url = new URL(window.location.href);
    var copy = getEmptyRescueCopy();
    var filters = [];
    url.searchParams.forEach(function (val, key) {
      if (/^gf_\d+$/.test(key) && val) {
        val.split(',').forEach(function (v) {
          v = decodeURIComponent(v).trim();
          if (v && v !== '0' && v !== '1') {
            var translated = (IS_EN_LOCALE && translationsMap && translationsMap[v]) || v;
            filters.push({ key: key, value: translated });
          } else if (v === '1' && key) {
            filters.push({ key: key, value: copy.inStock });
          }
        });
      }
    });
    return filters;
  }

  function isEmptyState() {
    if (document.documentElement.classList.contains('spf-empty')) return true;
    if (document.body.classList.contains('spf-empty')) return true;
    var tree = document.getElementById('gf-tree');
    if (!tree) return false;
    var blocks = tree.querySelectorAll('.gf-option-block');
    var filters = getActiveFiltersFromUrl();
    return blocks.length === 0 && filters.length > 0;
  }

  function ensureEmptyRescue() {
    var existing = document.getElementById('tk-empty-rescue');
    if (!isEmptyState()) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    var contents = document.querySelector('#gf-tree .gf-filter-contents') || document.getElementById('gf-tree');
    if (!contents) return;
    var filters = getActiveFiltersFromUrl();
    var url = new URL(window.location.href);
    [...url.searchParams.keys()].forEach(function (k) {
      if (/^gf_/.test(k)) url.searchParams.delete(k);
    });
    var clearAllUrl = url.toString();
    var div = document.createElement('div');
    div.id = 'tk-empty-rescue';
    div.style.cssText = 'padding:24px 16px;text-align:center;color:#3B1B31;';
    var chipsHtml = filters.map(function (f) {
      return '<span style="display:inline-flex;align-items:center;padding:6px 12px;margin:4px;border:1px solid #e5e5e5;border-radius:999px;background:#fafafa;font-size:12px;">' +
        f.value + '</span>';
    }).join('');
    var copy = getEmptyRescueCopy();
    div.innerHTML =
      '<div style="font-size:14px;font-weight:600;margin-bottom:8px;">' + copy.title + '</div>' +
      '<div style="font-size:13px;color:#9A8F85;margin-bottom:12px;">' + copy.subtitle + '</div>' +
      '<div style="margin-bottom:14px;display:flex;flex-wrap:wrap;justify-content:center;gap:4px;">' + chipsHtml + '</div>' +
      '<a href="' + clearAllUrl + '" style="display:inline-block;padding:10px 18px;border:1px solid #3B1B31;border-radius:999px;background:#fff;font-size:13px;font-weight:600;color:#3B1B31;text-decoration:none;">' + copy.clearAll + '</a>';
    contents.appendChild(div);
  }

  var emptyObserver = new MutationObserver(function () { ensureEmptyRescue(); });
  function startEmptyObserver() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return setTimeout(startEmptyObserver, 300);
    emptyObserver.observe(tree, { childList: true, subtree: true, attributeFilter: ['class'] });
    emptyObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    ensureEmptyRescue();
  }
  startEmptyObserver();

  injectControlBarStyles();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectControlBarStyles);
  }

  function parseNum(s) {
    if (s == null) return NaN;
    var t = String(s).trim().replace(/\s+/g, '').replace(',', '.');
    if (t === '') return NaN;
    var n = parseFloat(t);
    return isFinite(n) ? n : NaN;
  }

  var PINNED_FIRST = [
    'skladem', 'in stock',
    'není skladem', 'not in stock', 'out of stock',
  ];

  function getLabelText(li) {
    var labelEl = li.querySelector('.gf-label, .gf-option-value');
    return labelEl ? labelEl.textContent.trim() : '';
  }

  function sortBlock(block) {
    var list = block.querySelector('.gf-option-box');
    if (!list) return;
    var items = [];
    var hidden = [];
    var children = list.children;
    for (var i = 0; i < children.length; i++) {
      var li = children[i];
      if (li.tagName !== 'LI') continue;
      if (li.classList.contains('hidden-box')) { hidden.push(li); continue; }
      items.push(li);
    }
    if (items.length < 2) return;

    var sorted = null;

    var pinnedHits = items.map(function (li) {
      return PINNED_FIRST.indexOf(getLabelText(li).toLowerCase());
    });
    if (pinnedHits.every(function (idx) { return idx >= 0; })) {
      var pairs = items.map(function (li, i) { return { li: li, p: pinnedHits[i] }; });
      pairs.sort(function (a, b) { return a.p - b.p; });
      sorted = pairs.map(function (p) { return p.li; });
    }

    if (!sorted) {
      var nums = [];
      var allNumeric = true;
      for (var j = 0; j < items.length; j++) {
        var n = parseNum(getLabelText(items[j]));
        if (isNaN(n)) { allNumeric = false; break; }
        nums.push({ li: items[j], n: n });
      }
      if (allNumeric) {
        nums.sort(function (a, b) { return a.n - b.n; });
        sorted = nums.map(function (p) { return p.li; });
      }
    }

    block.setAttribute('data-tk-sortmode', sorted ? (pinnedHits.every(function (idx) { return idx >= 0; }) ? 'pinned' : 'numeric') : 'text');

    if (!sorted) return;

    var alreadySorted = true;
    for (var k = 0; k < sorted.length; k++) {
      if (sorted[k] !== items[k]) { alreadySorted = false; break; }
    }
    if (alreadySorted) return;

    var frag = document.createDocumentFragment();
    for (var m = 0; m < sorted.length; m++) frag.appendChild(sorted[m]);
    for (var h = 0; h < hidden.length; h++) frag.appendChild(hidden[h]);
    list.appendChild(frag);
  }

  function formatNum(n) {
    try { return Number(n).toLocaleString('cs-CZ'); }
    catch (e) { return String(n); }
  }

  function fireChange(el) {
    try { el.dispatchEvent(new Event('change', { bubbles: true })); }
    catch (e) {
      var ev = document.createEvent('Event');
      ev.initEvent('change', true, true);
      el.dispatchEvent(ev);
    }
  }

  function setSliderRange(block, minVal, maxVal) {
    var minInput = block.querySelector('.gf-range-min');
    var maxInput = block.querySelector('.gf-range-max');
    if (!minInput || !maxInput) return;

    minInput.value = minVal;
    minInput.setAttribute('data-value', minVal);
    maxInput.value = maxVal;
    maxInput.setAttribute('data-value', maxVal);

    var slider = block.querySelector('.gf-range-slider');
    if (slider && slider.noUiSlider && typeof slider.noUiSlider.set === 'function') {
      try { slider.noUiSlider.set([Number(minVal), Number(maxVal)]); } catch (e) { }
    }

    fireChange(maxInput);
  }

  function syncChipActive(block) {
    var minInput = block.querySelector('.gf-range-min');
    var maxInput = block.querySelector('.gf-range-max');
    if (!minInput || !maxInput) return;
    var minV = parseNum(minInput.value);
    var maxV = parseNum(maxInput.value);
    var minBound = parseNum(minInput.getAttribute('data-min-value'));
    var maxBound = parseNum(maxInput.getAttribute('data-max-value'));
    var atFullRange = minV === minBound && maxV === maxBound;
    var isPoint = !isNaN(minV) && minV === maxV && !atFullRange;
    var chips = block.querySelectorAll('.tk-filter-chip');
    for (var i = 0; i < chips.length; i++) {
      var v = parseNum(chips[i].getAttribute('data-value'));
      if (isPoint && v === minV) chips[i].classList.add('is-active');
      else chips[i].classList.remove('is-active');
    }
  }

  var tkFilterValuesCache = null;
  var tkFilterValuesLoading = null;

  var FILTER_VALUES_MAX_PAGES = 10;

  function parseFilterValuesPage(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var script = doc.querySelector('script[data-tk-filter-values]');
      if (!script) return { data: {}, pages: 1 };
      var data = JSON.parse(script.textContent) || {};
      var pages = parseInt(script.getAttribute('data-pages'), 10) || 1;
      return { data: data, pages: pages };
    } catch (e) {
      return { data: {}, pages: 1 };
    }
  }

  function mergeFilterValues(acc, next) {
    for (var key in next) {
      if (!Object.prototype.hasOwnProperty.call(next, key)) continue;
      var arr = next[key];
      if (!arr || !arr.length) continue;
      if (!acc[key]) acc[key] = [];
      for (var i = 0; i < arr.length; i++) {
        if (acc[key].indexOf(arr[i]) === -1) acc[key].push(arr[i]);
      }
    }
    return acc;
  }

  function loadFilterValues() {
    if (tkFilterValuesCache) return Promise.resolve(tkFilterValuesCache);
    if (tkFilterValuesLoading) return tkFilterValuesLoading;
    var path = window.location.pathname;
    var m = path.match(/^(?:\/[a-z]{2})?\/collections\/[^/]+/);
    if (!m) {
      tkFilterValuesCache = {};
      return Promise.resolve(tkFilterValuesCache);
    }
    var basePath = m[0];
    var firstUrl = basePath + '?section_id=tk-filter-values';

    tkFilterValuesLoading = fetch(firstUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var first = parseFilterValuesPage(html);
        var merged = {};
        mergeFilterValues(merged, first.data);

        if (first.pages <= 1) return merged;

        var maxPage = Math.min(first.pages, FILTER_VALUES_MAX_PAGES);
        var promises = [];
        for (var p = 2; p <= maxPage; p++) {
          promises.push(
            fetch(basePath + '?section_id=tk-filter-values&page=' + p, { credentials: 'same-origin' })
              .then(function (r) { return r.ok ? r.text() : ''; })
              .then(function (h) { return parseFilterValuesPage(h).data; })
              .catch(function () { return {}; })
          );
        }
        return Promise.all(promises).then(function (results) {
          for (var i = 0; i < results.length; i++) mergeFilterValues(merged, results[i]);
          return merged;
        });
      })
      .then(function (merged) {
        tkFilterValuesCache = merged || {};
        var blocks = document.querySelectorAll('.gf-option-block');
        for (var i = 0; i < blocks.length; i++) renderPresets(blocks[i]);
        return tkFilterValuesCache;
      })
      .catch(function () {
        tkFilterValuesCache = {};
        return tkFilterValuesCache;
      });
    return tkFilterValuesLoading;
  }

  var PRESETS_VISIBLE = 3;

  function renderPresets(block) {
    var container = block.querySelector('.tk-filter-presets');
    if (!container) return;
    if (container.getAttribute('data-tk-rendered') === '1') {
      syncChipActive(block);
      return;
    }

    var unit = container.getAttribute('data-unit') || '';
    var key = container.getAttribute('data-key') || '';

    var values = null;
    if (key) {
      if (!tkFilterValuesCache) {
        loadFilterValues();
        return;
      }
      var dyn = tkFilterValuesCache[key];
      if (dyn && dyn.length) values = dyn.slice();
    }
    if (!values) {
      var raw = container.getAttribute('data-presets') || '';
      values = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    if (!values.length) return;

    var numeric = [];
    for (var i = 0; i < values.length; i++) {
      var n = parseNum(values[i]);
      if (!isNaN(n)) numeric.push(n);
    }
    numeric.sort(function (a, b) { return a - b; });

    var sliderEl = block.querySelector('.gf-range-slider');
    var sliderMin = sliderEl ? parseNum(sliderEl.getAttribute('data-min')) : NaN;
    var sliderMax = sliderEl ? parseNum(sliderEl.getAttribute('data-max')) : NaN;
    if (!isNaN(sliderMin) && !isNaN(sliderMax)) {
      numeric = numeric.filter(function (v) { return v >= sliderMin && v <= sliderMax; });
    }
    if (!numeric.length) return;

    var hiddenCount = numeric.length - PRESETS_VISIBLE;
    var hasMore = hiddenCount > 1;

    var html = '';
    for (var k = 0; k < numeric.length; k++) {
      var v = numeric[k];
      var label = formatNum(v) + (unit ? ' ' + unit : '');
      var cls = 'tk-filter-chip';
      if (hasMore && k >= PRESETS_VISIBLE) cls += ' is-collapsed';
      html += '<button type="button" class="' + cls + '" data-value="' + v + '">' + label + '</button>';
    }
    if (hasMore) {
      html += '<button type="button" class="tk-filter-chip-more" data-tk-presets-expand>+' + hiddenCount + '</button>';
    }
    container.innerHTML = html;
    container.setAttribute('data-tk-rendered', '1');

    container.addEventListener('click', function (e) {
      var more = e.target && e.target.closest ? e.target.closest('.tk-filter-chip-more') : null;
      if (more) {
        e.preventDefault();
        var collapsed = container.querySelectorAll('.tk-filter-chip.is-collapsed');
        for (var j = 0; j < collapsed.length; j++) collapsed[j].classList.remove('is-collapsed');
        if (more.parentNode) more.parentNode.removeChild(more);
        return;
      }
      var chip = e.target && e.target.closest ? e.target.closest('.tk-filter-chip') : null;
      if (!chip) return;
      e.preventDefault();
      var v = chip.getAttribute('data-value');
      setSliderRange(block, v, v);
      var siblings = block.querySelectorAll('.tk-filter-chip');
      for (var j2 = 0; j2 < siblings.length; j2++) siblings[j2].classList.remove('is-active');
      chip.classList.add('is-active');
    });

    var minInput = block.querySelector('.gf-range-min');
    var maxInput = block.querySelector('.gf-range-max');
    if (minInput) minInput.addEventListener('change', function () { syncChipActive(block); });
    if (maxInput) maxInput.addEventListener('change', function () { syncChipActive(block); });

    syncChipActive(block);
  }

  loadFilterValues();

  var translationsMap = null;
  var translationsLoading = null;
  var IS_EN_LOCALE = (document.documentElement.lang || '').toLowerCase().startsWith('en');

  function loadTranslations() {
    if (translationsMap) return Promise.resolve(translationsMap);
    if (translationsLoading) return translationsLoading;
    var meta = document.querySelector('meta[name="tk-globo-translations-url"]');
    var url = meta && meta.getAttribute('content');
    if (!url) {
      translationsMap = {};
      return Promise.resolve(translationsMap);
    }
    translationsLoading = fetch(url)
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (m) {
        translationsMap = m || {};
        if (IS_EN_LOCALE) rewriteLabels();
        return translationsMap;
      });
    return translationsLoading;
  }

  if (IS_EN_LOCALE) loadTranslations();

  var colorSwatchMap = null;
  var colorSwatchLoading = null;

  function loadColorSwatchMap() {
    if (colorSwatchMap) return Promise.resolve(colorSwatchMap);
    if (colorSwatchLoading) return colorSwatchLoading;
    colorSwatchLoading = fetch('/?section_id=tk-color-swatch-map', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; })
      .then(function (html) {
        var map = {};
        if (html) {
          var i = html.indexOf('{');
          var j = html.lastIndexOf('}');
          if (i !== -1 && j > i) {
            try { map = JSON.parse(html.substring(i, j + 1)); } catch (e) { map = {}; }
          }
        }
        colorSwatchMap = map;
        injectColorSwatches();
        return colorSwatchMap;
      });
    return colorSwatchLoading;
  }
  loadColorSwatchMap();

  function lookupColorHex(label) {
    if (!colorSwatchMap || !label) return null;
    var txt = label.trim();
    if (colorSwatchMap[txt]) return colorSwatchMap[txt];
    if (translationsMap) {
      for (var cs in translationsMap) {
        if (translationsMap[cs] === txt && colorSwatchMap[cs]) return colorSwatchMap[cs];
      }
    }
    return null;
  }

  function isColorFilterBlock(block) {
    if (!block || !block.getAttribute) return false;
    var t = (block.getAttribute('data-filter-type') || '').toLowerCase();
    var id = (block.getAttribute('data-filter-id') || '').toLowerCase();
    if (t.indexOf('color-pattern') !== -1) return true;
    if (t.indexOf('barva') !== -1) return true;
    if (t.indexOf('color') !== -1 && t.indexOf('colour') === -1) {
      if (t.indexOf('shopify.color') !== -1 || t.indexOf('product_color') !== -1 || t === 'color') return true;
    }
    var titleEl = block.querySelector('.gf-block-title, .gf-block-title .h3, h3');
    if (titleEl) {
      var titleTxt = (titleEl.textContent || '').trim().toLowerCase();
      if (titleTxt === 'barva' || titleTxt === 'color' || titleTxt === 'farba' || titleTxt === 'barva mobilu') {
        return true;
      }
    }
    return false;
  }

  function injectColorSwatches(root) {
    if (!colorSwatchMap) return;
    var blocks = (root || document).querySelectorAll('#gf-tree .gf-option-block');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (!isColorFilterBlock(block)) continue;
      var items = block.querySelectorAll('.gf-option-box > li > a, .gf-option-box .gf-option-label');
      for (var j = 0; j < items.length; j++) {
        var a = items[j];
        if (a.querySelector('.tk-gf-color-circle')) continue;
        var labelEl = a.querySelector('.gf-label, .gf-option-value');
        var labelTxt = labelEl ? (labelEl.textContent || '').trim() : (a.textContent || '').trim();
        if (!labelTxt) continue;
        var hex = lookupColorHex(labelTxt);
        if (!hex) continue;
        var circle = document.createElement('span');
        circle.className = 'tk-gf-color-circle';
        circle.setAttribute('aria-hidden', 'true');
        circle.style.background = hex;
        if (/^#(f[0-9a-f]{2}|fff)/i.test(hex)) {
          circle.classList.add('tk-gf-color-circle--light');
        }
        a.insertBefore(circle, a.firstChild);
      }
    }
    var pills = (root || document).querySelectorAll('#gf-tree .selected-item.gf-option-label');
    for (var k = 0; k < pills.length; k++) {
      var p = pills[k];
      if (p.querySelector('.tk-gf-color-circle')) continue;
      var anchor = p.querySelector('a') || p;
      var lblEl = anchor.querySelector('.gf-label');
      var lblTxt = lblEl ? (lblEl.textContent || '').trim() : '';
      if (!lblTxt) continue;
      var hex2 = lookupColorHex(lblTxt);
      if (!hex2) continue;
      var c2 = document.createElement('span');
      c2.className = 'tk-gf-color-circle tk-gf-color-circle--pill';
      c2.setAttribute('aria-hidden', 'true');
      c2.style.background = hex2;
      if (/^#(f[0-9a-f]{2}|fff)/i.test(hex2)) c2.classList.add('tk-gf-color-circle--light');
      anchor.insertBefore(c2, anchor.firstChild);
    }
  }

  function rewriteLabels(root) {
    if (!IS_EN_LOCALE || !translationsMap) return;
    var nodes = (root || document).querySelectorAll('#gf-tree .gf-label, #gf-tree .gf-option-value');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var txt = (el.textContent || '').trim();
      if (!txt) continue;
      var en = translationsMap[txt];
      if (en && txt !== en) {
        el.textContent = en;
        el.setAttribute('data-tk-rewritten', '1');
      }
    }
    var pills = (root || document).querySelectorAll('#gf-tree .selected-item .gf-label');
    for (var j = 0; j < pills.length; j++) {
      var p = pills[j];
      var t2 = (p.textContent || '').trim();
      if (!t2) continue;
      var en2 = translationsMap[t2];
      if (en2 && t2 !== en2) {
        p.textContent = en2;
        p.setAttribute('data-tk-rewritten', '1');
      }
    }
    resortByTranslatedLabel(root);
  }

  var EN_COLLATOR = (function () {
    try { return new Intl.Collator('en', { numeric: true, sensitivity: 'base' }); }
    catch (e) { return null; }
  })();

  function resortByTranslatedLabel(root) {
    if (!IS_EN_LOCALE) return;
    var blocks = (root || document).querySelectorAll('#gf-tree .gf-option-block');
    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var mode = block.getAttribute('data-tk-sortmode');
      if (mode === 'pinned' || mode === 'numeric') continue;
      var list = block.querySelector('.gf-option-box');
      if (!list) continue;
      var items = [];
      var hidden = [];
      var ch = list.children;
      for (var i = 0; i < ch.length; i++) {
        var li = ch[i];
        if (li.tagName !== 'LI') continue;
        if (li.classList.contains('hidden-box')) { hidden.push(li); continue; }
        items.push(li);
      }
      if (items.length < 2) continue;
      var withLabel = items.map(function (li) { return { li: li, t: getLabelText(li) }; });
      if (withLabel.some(function (x) { return !x.t; })) continue;
      var sorted = withLabel.slice().sort(function (a, c) {
        return EN_COLLATOR ? EN_COLLATOR.compare(a.t, c.t) : a.t.localeCompare(c.t);
      }).map(function (x) { return x.li; });
      var same = true;
      for (var k = 0; k < sorted.length; k++) {
        if (sorted[k] !== items[k]) { same = false; break; }
      }
      if (same) continue;
      var frag = document.createDocumentFragment();
      for (var m = 0; m < sorted.length; m++) frag.appendChild(sorted[m]);
      for (var h = 0; h < hidden.length; h++) frag.appendChild(hidden[h]);
      list.appendChild(frag);
    }
  }

  function scan() {
    var blocks = document.querySelectorAll('.gf-option-block');
    for (var i = 0; i < blocks.length; i++) {
      sortBlock(blocks[i]);
      renderPresets(blocks[i]);
      hookCzkSliderNormalization(blocks[i]);
      hookRangeInputPreRead(blocks[i]);
    }
    normalizeCzkGloboRangeInputs();
    normalizeEurGloboRangeInputs();
    normalizeCzkNoUiLabels();
    reconcileStaleSliderRanges();
    stripCurrencyFromNonPriceSliders();
    if (IS_EN_LOCALE) {
      if (!translationsMap) loadTranslations().then(function () { rewriteLabels(); });
      else rewriteLabels();
    }
    if (!colorSwatchMap) loadColorSwatchMap().then(function () { injectColorSwatches(); });
    else injectColorSwatches();
  }

  function hookCzkSliderNormalization(block) {
    if (!block) return;
    var slider = block.querySelector('.gf-range-slider');
    if (!slider || !slider.noUiSlider || slider._tkNormHooked) return;
    if (typeof slider.noUiSlider.on !== 'function') return;
    slider._tkNormHooked = true;
    var renorm = function () {
      normalizeCzkGloboRangeInputs(block);
      normalizeEurGloboRangeInputs(block);
      normalizeCzkNoUiLabels(block);
      stripCurrencyFromNonPriceSliders(block);
    };
    slider.noUiSlider.on('update', renorm);
    slider.noUiSlider.on('slide', renorm);
    slider.noUiSlider.on('drag', renorm);
  }

  function preReadNormalizeValue(input) {
    if (!input) return;
    var raw = (input.value || '').trim();
    if (!raw) return;
    var clean = raw.replace(/[\s ]/g, '');
    var hasComma = clean.indexOf(',') >= 0;
    var hasDot = clean.indexOf('.') >= 0;
    if (hasComma && hasDot) {
      clean = clean.replace(/,/g, '');
    } else if (hasComma) {
      if (/,\d{1,2}$/.test(clean)) {
        clean = clean.replace(',', '.');
      } else {
        clean = clean.replace(/,/g, '');
      }
    }
    var num = parseFloat(clean);
    if (isNaN(num)) return;
    var next = String(num);
    if (input.value !== next) input.value = next;
  }

  function preReadNormalize(e) {
    var input = e.target;
    if (!input || (!input.classList.contains('gf-range-min') && !input.classList.contains('gf-range-max'))) return;
    var block = input.closest && input.closest('.gf-option-block');
    if (block) {
      var pair = block.querySelectorAll('.gf-range-min, .gf-range-max');
      for (var i = 0; i < pair.length; i++) preReadNormalizeValue(pair[i]);
    } else {
      preReadNormalizeValue(input);
    }
  }

  function hookRangeInputPreRead(block) {
    if (!block) return;
    var inputs = block.querySelectorAll('.gf-range-min, .gf-range-max');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input._tkPreReadHooked) continue;
      input._tkPreReadHooked = true;
      input.addEventListener('change', preReadNormalize, true);
    }
  }

  var DRAWER_MAX = 989;

  function isTablet() { return window.innerWidth <= DRAWER_MAX; }

  function syncOffcanvasMode() {
    var html = document.documentElement;
    var tablet = isTablet();
    var has = html.classList.contains('gf-offcanvas');
    if (tablet && !has) {
      html.classList.add('gf-offcanvas');
    } else if (!tablet && has) {
      html.classList.remove('gf-offcanvas', 'offcanvas-open');
    }
  }

  syncOffcanvasMode();
  window.addEventListener('resize', syncOffcanvasMode);
  document.addEventListener('DOMContentLoaded', syncOffcanvasMode);
  window.addEventListener('load', syncOffcanvasMode);

  var htmlClassObserver = new MutationObserver(syncOffcanvasMode);
  htmlClassObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!document.body.classList.contains('offcanvas-open')) return;
    if (window.globofilter && typeof window.globofilter.toggleCanvas === 'function') {
      window.globofilter.toggleCanvas();
    } else {
      document.body.classList.remove('offcanvas-open');
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.id === 'gf-overlay' || e.target.closest('#gf-overlay')) {
      if (window.globofilter && typeof window.globofilter.toggleCanvas === 'function') {
        window.globofilter.toggleCanvas();
      } else {
        document.body.classList.remove('offcanvas-open');
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; scan(); });
  }

  var observer = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('.gf-option-block, .gf-option-box, li')) ||
            (node.querySelector && node.querySelector('.gf-option-block'))) {
          schedule();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  function startTreeContentScanObserver() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return setTimeout(startTreeContentScanObserver, 300);
    var treeScanObserver = new MutationObserver(function () { schedule(); });
    treeScanObserver.observe(tree, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
  startTreeContentScanObserver();
})();
